import { FlowRunner } from '@features/onboarding/Onboarding';

/**
 * Dedicated survey / eForm runner.
 *
 * Surveys and eForms are flow instances, so they reuse the shared flow engine
 * (`FlowRunner`) — but via the `survey` variant, which drops all onboarding
 * chrome (no "Onboarding" eyebrow, survey back button, "response submitted"
 * completion copy). Reads `instance` / `template` / `title` / `backTo` from the
 * query string, same as the onboarding entry point.
 */
export function SurveyRunner(): JSX.Element {
  return <FlowRunner variant="survey" />;
}
